<ng-container *transloco="let t;">
    <div class="container d-flex justify-content-center align-items-center">
        <div class="w-100 py-4" style="max-width: 80rem;">
            <breadcrumb [items]='[{ label: t("header.frontpage"), route: "/"} ]'></breadcrumb>
            <div class="content-box scroll-to">
                <div class="row g-2">
                    <div class="col">
                        <h4>{{ t('patientschemas.title') }}</h4>
                    </div>
                    <div class="col-md-auto me-auto">
                        <nav class="mb-3">
                            <div class="nav nav-pills d-grid d-block d-md-inline-flex gap-2 justify-content-lg-end"
                                id="nav-tab" role="tablist" style="max-width: 600px;">
                                <button class="btn btn-outline-primary active" #tabButton id="nav-active-schemas-tab"
                                    data-bs-toggle="tab" data-bs-target="#nav-active-schemas" type="button" role="tab"
                                    aria-controls="nav-active-schemas" aria-selected="true"
                                    (shown.bs.tab)="onTabShown('active')">
                                    {{ t('schemapagination.active') }}
                                    <span class="badge text-bg-danger">{{activeSchemaCount()}}</span>
                                </button>
                                <button class="btn btn-outline-primary" #tabButton id="nav-historical-schemas-tab"
                                    data-bs-toggle="tab" data-bs-target="#nav-historical-schemas" type="button"
                                    role="tab" aria-controls="nav-historical-schemas" aria-selected="false"
                                    (shown.bs.tab)="onTabShown('historical')">
                                    {{ t('schemapagination.historical') }}
                                    <span class="badge text-bg-danger">{{historicalSchemaCount()}}</span>
                                </button>
                                <ng-container *ngIf="hasOthersSchemaAccess() as hasOthersSchemaAccess">
                                    <button *ngIf="hasOthersSchemaAccess" class="btn btn-outline-primary gap-1"
                                        #tabButton id="nav-others-tab" data-bs-toggle="tab" data-bs-target="#nav-others"
                                        type="button" role="tab" aria-controls="nav-others" aria-selected="false"
                                        (shown.bs.tab)="onTabShown('others')">
                                        {{ t('schemapagination.others') }}
                                        <span class="badge text-bg-danger">{{othersSchemaCount()}}</span>
                                    </button>
                                </ng-container>
                                <ng-container
                                    *ngIf="hasOthersHistoricalSchemaAccess() as hasOthersHistoricalSchemaAccess">
                                    <button *ngIf="hasOthersHistoricalSchemaAccess"
                                        class="btn btn-outline-primary gap-1" #tabButton id="nav-othershistorical-tab"
                                        data-bs-toggle="tab" data-bs-target="#nav-others-historical" type="button"
                                        role="tab" aria-controls="nav-others" aria-selected="false"
                                        (shown.bs.tab)="onTabShown('othershistorical')">
                                        {{ t('schemapagination.othershistorical') }}
                                        <span class="badge text-bg-danger">{{othersHistoricalSchemaCount()}}</span>
                                    </button>
                                </ng-container>
                            </div>
                        </nav>
                    </div>
                </div>
                <div *ngIf="selectedTab == 'historical'" class="mb-2">
                    <div class="card card-body mb-3 schema-terms-info">
                        <div class="fw-medium">
                            {{ t('schema.historicalschemasinfo') }}
                        </div>
                    </div>
                </div>
                <div class="tab-content" id="nav-patients-schemas-content">
                    <div class="tab-pane fade show active" id="nav-active-schemas" role="tabpanel"
                        aria-labelledby="nav-active-schemas-tab">
                        <patient-active-schema-list></patient-active-schema-list>
                    </div>
                    <div class="tab-pane fade" id="nav-historical-schemas" role="tabpanel"
                        aria-labelledby="nav-historical-schemas-tab">
                        <historical-schema-list></historical-schema-list>
                    </div>
                    <div class="tab-pane fade" id="nav-others" role="tabpanel" aria-labelledby="nav-others-tab">
                        <patient-others-schema-list></patient-others-schema-list>
                    </div>
                    <div class="tab-pane fade" id="nav-others-historical" role="tabpanel"
                        aria-labelledby="nav-others-tab">
                        <others-historical-schema-list></others-historical-schema-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>